import React, { Component } from 'react'
import {connect} from 'react-redux'

import moment from 'moment'

import { saveAttendances } from '../../actions/Attendances'
import { setMemberLastPaid } from '../../actions/Members'

const initialState = {
  grid: null,
  start_month: null,
  action: true,
  max: null,
  min: null,
  presenceCounter: null,
  course_id: null,
  course_color: null
}
let start = null
const wd = ['L', 'M', 'M', 'G', 'V', 'S', 'D']

class Calendar extends Component {
  constructor () {
    super()
    this.state = initialState
  }
  changeMonth (n) {
    if (n === 0) {
      this.setState({
        start_month: start
      })
    } else {
      let nm = moment.unix(this.state.start_month).utc().add(n, 'months').startOf('month').startOf('day').unix() //.utc().unix()
      this.setState({
        start_month: nm
      })
    }
  }
  componentDidUpdate (prevProps, prevState) {
    if (prevState.start_month !== this.state.start_month) {
      this.popolateGrid()
    }
    if (prevProps.attendances.ajaxSpinner && (!this.props.attendances.ajaxSpinner && this.props.attendances.ajaxStatus === null)) {
      this.popolateGrid()
    }
    if (prevState.course_id !== this.state.course_id) {
      this.popolateGrid()
    }
  }
  popolateGrid () {
    let currentMonth = moment.unix(this.state.start_month).utc()
    // console.log(currentMonth.startOf('month').unix())
    let grid = []
    const dates = this.props.dates
    let presenceCounter = 0
    let lastPaid = 0
    for (let x = 0; x < dates.length; x++) {
      // if (dates[x].present === 1) {
      if (dates[x].present === 1) { // && dates[x].course_id === this.state.course_id
        presenceCounter++
      }
      if (dates[x].paid === 1) {
        lastPaid = dates[x].emission_date
      }
    }

    let courses = []
    this.props.courses.list.forEach((obj) => {
      courses[obj.id] = obj
    })

    for (var m = 0; m < 3; m++) {
      let count = 0
      let sc = currentMonth.isoWeekday()
      let spacer = []
      for (let s = 1; s < sc; s++) {
        count++
        spacer.push(s)
      }

      let days = []
      for (let d = 1; d <= currentMonth.daysInMonth(); d++) {
        count++
        const epoch = moment.unix(currentMonth.unix()).add((d - 1), 'days').utc().startOf('day').unix()
        var exists = dates.filter((obj) => {
          return obj.emission_date === epoch
        })

        let paid = 0
        let present = 0
        let css = ''
        if (exists.length > 0) {
          paid = exists[0].paid
          present = exists[0].present
          if (paid === 1) {
            css += ' paid ' + courses[exists[0].course_id].color
          }
          if (present === 1) {
            css += ' present x' + courses[exists[0].course_id].color
          }
          if (present === 1 && paid === 0) {
            css += ' alert'
          }
          if (moment.utc().startOf('day').unix() === epoch) {
            css += ' today'
          }
        }
        days.push({
          number: d,
          epoch,
          css,
          paid,
          present
        })
      }
      let after = []
      let hm = (count % 7) - 7
      if (hm < 7) {
        hm = hm * -1
      }
      if (hm === 7) {
        hm = 0
      }
      for (let s = 0; s < hm; s++) {
        after.push(s)
      }
      let month = {
        label: currentMonth.format('MMMM YYYY'),
        spacer,
        days,
        after
      }
      // if (currentMonth.unix() <= this.state.max) {
      grid.push(month)
      // }
      currentMonth.add(1, 'month')
    }
    this.setState({ grid, presenceCounter })
    this.props.setMemberLastPaid({
      id: this.props.selected,
      last_paid: lastPaid
    })
  }
  saveAction (d) {
    let a = {
      account_holder: this.props.selected,
      emission_date: d.epoch,
      paid: d.paid,
      present: d.present,
      course_id: this.state.course_id
    }
    if (this.state.action) {
      a.present = (a.present === 1) ? 0 : 1
    } else {
      a.paid = (a.paid === 1) ? 0 : 1
    }
    this.props.saveAttendances(a)
  }
  componentDidMount () {
    // set start calendar
    const today = moment().utc().startOf('month').startOf('day').unix()
    const fy = this.props.fiscalyear
    let cur = fy.list.filter((obj) => {
      return obj.id === fy.current
    })[0]
    if (today > cur.end_date) {
      start = cur.end_date
    } else if (today < cur.start_date) {
      start = cur.start_date
    } else {
      start = today
    }
    // set course id
    const c = this.props.courses.list
    const dow = moment().utc().day()
    let cid = 0
    let color = ''
    c.forEach((obj) => {
      obj.schedule_list.forEach((o) => {
        if (o.day_of_week === dow) {
          cid = obj.id
          color = obj.color
        }
      })
    })
    if (cid === 0 && c.length > 0) {
      cid = c[0].id
      color = c[0].color
    }
    // set state
    this.setState({
      start_month: start,
      min: cur.start_date,
      max: cur.end_date,
      course_id: cid,
      course_color: color
    })
    this.end.scrollIntoView({ behavior: 'smooth' })
    // this.popolateGrid()
  }
  changeCourse (event) {
    const val = parseInt(event.target.value, 10)
    const course = this.props.courses.list.filter((obj) => {
      return obj.id === val
    })[0]
    this.setState({
      course_id: val,
      course_color: course.color
    })
    // this.popolateGrid()
  }
  render () {
    const grid = this.state.grid
    const courses = this.props.courses.list
    return (
      <div className="att-grid" ref={(el) => { this.end = el }}>
        <button
          className="lnk-close-cal"
          onClick={() => this.props.closeCalendar()}
        >
          <i className="fas fa-times"></i>
        </button>
        <h3>{this.props.selectedName}</h3>
        <p>Presenze totali: <b>{this.state.presenceCounter}</b></p>
        {
          // (this.state.action && this.state.course_id !== null) && (
          (this.state.course_id !== null) && (
            <div className="att-course">
              <label>
                  Corso
                <select
                  onChange={event => this.changeCourse(event)}
                  value={this.state.course_id}
                >
                  {
                    courses !== null && (
                      courses.map((m, index) => {
                        return (
                          <option key={index} value={m.id}>{m.name}</option>
                        )
                      })
                    )
                  }
                </select>
              </label>
            </div>
          )
        }
        <div className="att-header">
          <div className="att-action">
            <label className="switch">
              <input type="checkbox"
                onChange={event => this.setState({ action: event.target.checked })}
                checked={this.state.action}
                value={this.state.action}
              />
              <span className="slider round"></span>
              <div className="sl-txt">
                {
                  this.state.action && (
                    'Gestisci presenze'
                  )
                }
                {
                  !this.state.action && (
                    'Gestisci pagamenti'
                  )
                }
              </div>
            </label>
          </div>
          <div className="att-move">
            <button onClick={() => this.changeMonth(-1)} className="lnk-cal"><i className="fas fa-arrow-left"></i></button>
            <button onClick={() => this.changeMonth(0)} className="lnk-cal"><i className="fas fa-circle"></i></button>
            <button onClick={() => this.changeMonth(1)} className="lnk-cal"><i className="fas fa-arrow-right"></i></button>
          </div>
        </div>
        {
          grid !== null && (
            grid.map((m, i) => {
              return (
                <div key={i} className="month">
                  <div className="label">{m.label}</div>
                  <div className="days">
                    <div className="day-labels">
                      {
                        wd.map((d, i2) => {
                          return (
                            <div className="day-name" key={i2}>{d}</div>
                          )
                        })
                      }
                    </div>
                    {
                      m.spacer.map((d, i2) => {
                        return (
                          <div className="spacer" key={i2}></div>
                        )
                      })
                    }
                    {
                      m.days.map((d, i2) => {
                        return (
                          <div className={'day ' + d.css} key={i2} onClick={() => this.saveAction(d)}>
                            <span>{d.number}</span>
                          </div>
                        )
                      })
                    }
                    {
                      m.after.map((d, i2) => {
                        return (
                          <div className="spacer" key={i2}></div>
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
          )
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveAttendances, setMemberLastPaid })(Calendar)



// WEBPACK FOOTER //
// ./src/components/Attendances/Calendar.js